/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/9
 * @updateTime 2021/11/9
 * @decription 保全申请=》编辑保全基本信息
 */
import MyTitle from '../../../components/common/myTitle';
// 案由选择
import acSelectAy from '@/components/app/select-ay/index.vue';
// 案由行为选择组件
import acSelectAyXw from '@/components/app/select-ay-xw/index.vue';
import validate from '@/utils/validator/validator';
import {
    typeBqlb,
    typeBqlx,
    typeFsccFsqj,
    typeDbzt,
    typeTjrlx,
    typeAjlx,
    typeDbqk,
    typeWxdb,
}
    from '../../../filters/index';
import {Notify,Dialog} from 'vant';
import {columnsDbqk, columnsAjlx, columnsWxdb, columnsSQBQDbqk, columnsAhnf} from '../../../utils/option';
import {
    SqbqjeRule,
    ajlxRule,
    wdbyy,
    ahNfRule,
    FydzRule,
    AjlxdzRule,
    AjxhRule, cAyNameRule, cXzaymcRule, dbqkRule
} from '@/utils/validator/rules';

export default {
    data() {
        return {
            // 对接在线服务网新增——案号下拉列表
            ahList: [],
            // 对接在线服务网新增——是否显示诉讼案号下拉列表
            showSsah: false,
            bqJbxx: {
                // 对接在线服务网新增——案号代码
                cAhdm: '',
                cId:'',
                cBqah: '',//案号
                cAhNf: '',//案号年份
                cAhFydz: '',//案号法院代字
                cAhAjlxdz: '',//案号案件类型代字
                cAhAjxh: '',//案号序号
                nAjlx:'',//案件类型
                nAjlxText:'',
                cAy:'',//案由
                // 案由显示名称
                cAyName: '',
                // 案由代码值
                cAycode: '',
                // 行政行为代码值
                cAyxzxw: '',
                // 行政行为名称
                cAyxzxwName: '',
                // 行政案由名称
                cXzaymc: '',
                // 申请法院
                nSqfy: '',
                cSqdyfymc: '',
                cBqlx: '',
                cBqlb: '',
                cBqlbText: '',
                cFsqj: '',
                nSqbqje: '',
                nSqbqdcsfy: '',
                cDbzt: '',
                cTjr: '',
                dtTjsj: '', // 提交日期, 未返回值暂用创建申请日期
                dtCreatetime: '', // 创建申请日期
                cTjrlx: '',
                cDbqk: '',
                cDbqkText: '',
                nWdbyy:'',//无担保原因
                nWdbyyText:'',
            },
            showAhNf: false, //案号年份
            timeList:[], //年份列表
            columnsAhnf: columnsAhnf,
            // 是否显示案由弹层
            showAyPopup: false,
            // 是否显示案由行为弹层
            showAyXwPopup: false,
            isChangeDb:null,
            columnAJLX: columnsAjlx,
            columnDBQK: columnsDbqk,
            // 诉前保全-担保情况
            columnsSQBQDbqk: columnsSQBQDbqk,
            columnsWxdb:columnsWxdb,
            showDBQK: false,
            showAJLX: false,
            showWXDB:false,
            isWdbyy:false,

            ayLabel_1:'',
            ayLabel_2:''
        }
    },
    components: {
        MyTitle,
        acSelectAy,
        acSelectAyXw
    },
    created() {
        this.$axios.get('ssbq/api/nfs').then(res => {
            console.log('--res 000', res);
            let yearList2 = res.data.map(item => Object({text: Number(item), keyId: Number(item)}));
            console.log('--yearList2 000', yearList2);
            this.timeList=yearList2;
            // return yearList2
        })
        let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
        this.bqJbxx.cId = bqid
        this.getBqJbxx()
        // 对接在线服务网新增——获取案号下拉列表数据
        this.getAhList();
    },
    methods: {

        /**
         * @function
         * @description 对接在线服务网新增——获取案号下拉列表数据
         * @return {undefined} 无返回值
         */
        getAhList() {
            const params = {
                zxfwToken: localStorage.getItem('zxfwtoken')
            };
            this.$axios.get('ssbq/api/bqyzw/bqsq/ahList', params).then((res) => {
                if (res.code === 200) {
                    this.ahList = res.data;
                } else {
                    console.log('案号下拉列表获取失败');
                }
            });
        },

        /**
         * @function
         * @description 对接在线服务网新增——切换诉讼案号
         * @return {undefined} 无返回值
         */
        onConfirmSsah(item) {
            this.bqJbxx.cAhdm = item.cAhdm;
            this.bqJbxx.cBqah = item.cAh;
            // 案号年份，从中文案号里面截取出年份，不然加选案号列表的接口后提交接口会报500
            this.bqJbxx.cAhNf = this.bqJbxx.cBqah.slice(1, 5);
            console.log('案号代码：', this.bqJbxx.cAhdm);
            console.log('诉讼案号：', this.bqJbxx.cBqah);
            console.log('案号年份：', this.bqJbxx.cAhNf);
            this.showSsah = false;
        },

        //选择担保情况
        selectDbqk(){
            this.showDBQK = true;
        },
        //选择无需担保原因
        selectWxDb(){
            this.showWXDB = true;
        },
        //获取保全基本信息
        getBqJbxx() {
            return new Promise((resolve) => {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                this.$axios.get('ssbq/api/bqsqinfo?bqid=' + bqid).then(res => {
                    if(res.data.cBqlb == 1){
                        this.isChangeDb = true
                    }else{
                        this.isChangeDb = false
                    }
                    // 进行数据合并
                    const _bqJbxx = {
                        ...this.bqJbxx,
                        ...res.data
                    }
                    _bqJbxx.cAyName = _bqJbxx.cAy.split(';')[0];
                    // 保全类型文本
                    _bqJbxx.cBqlxText = typeBqlx(res.data.cBqlx);
                    // 保全类别文本
                    _bqJbxx.cBqlbText = typeBqlb(res.data.cBqlb);
                    // 非诉期间文本
                    _bqJbxx.cFsqjText = typeFsccFsqj(res.data.cFsqj);
                    // 担保状态文本
                    _bqJbxx.cDbztText = typeDbzt(res.data.cDbzt);
                    // 统计类型文本
                    _bqJbxx.cTjrlxText = typeTjrlx(res.data.cTjrlx);
                    // 是否显示担保信息
                    this.isShowDbxx = res.data.cDbqk;
                    // 担保情况文本
                    _bqJbxx.cDbqkText = typeDbqk(res.data.cDbqk);
                    // 案件类型文本
                    _bqJbxx.nAjlxText = typeAjlx(res.data.nAjlx);
                    // 无担保原因文本
                    _bqJbxx.nWdbyyText = typeWxdb(res.data.nWdbyy);
                    // 保全基本信息赋值
                    this.bqJbxx = _bqJbxx;
                    resolve();
                })
            })
        },
        //做信息项校验
        validateFormData: function () {
            // 校验规则
            let descriptor = {};
            // 保全类别为诉讼保全
            if (this.bqJbxx.cBqlb == 2) {
                // 诉讼保全
                descriptor.nAjlx = ajlxRule;
                // 案号
                descriptor.cAhNf = ahNfRule;
                // 当案号不用下拉选择时，才校验手填案号的字段项
                if (!this.ahList.length) {
                    descriptor.cAhFydz = new FydzRule(true,this.bqJbxx.nSqfy);
                    descriptor.cAhAjlxdz = new AjlxdzRule(true);
                    descriptor.cAhAjxh = new AjxhRule(true);
                }
                // 案由名称
                descriptor.cAy = cAyNameRule(true,this.ayLabel.label1);

                // 行政案件
                if (this.bqJbxx.nAjlx == 6) {
                    // 案由行为名称
                    descriptor.cAyxzxwName = cAyNameRule(true,this.ayLabel.label2);
                    // 行政案由
                    if(this.bqJbxx.cAhNf>=2021){
                        descriptor.cXzaymc=cXzaymcRule(true)
                    }
                }
            }
            if(this.bqJbxx.cBqlb == 2 && this.bqJbxx.cDbqk == 3){
                descriptor.nWdbyy = wdbyy;
            }
            // 申请保全金额
            descriptor.nSqbqje = new SqbqjeRule(true);
            // 担保情况
            descriptor.cDbqk = dbqkRule;
            let validated = validate(descriptor, this.bqJbxx);
            return validated;
        },
        //选择的担保情况保存到页面
        onConfirmDBQK(item) {
            if(item.keyId == 3){
                this.isWdbyy = true
            }
            if(item.keyId == 1){
                this.bqJbxx.nWdbyy = ''
                Dialog.confirm({
                    title: '标题',
                    message: ' “无需担保” 改为 “有担保” 后不能再修改，确认修改为 “有担保” ？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff',
                    confirmButtonText:'确认修改',
                    cancelButtonText:'返回'
                }).then(() => {
                    this.bqJbxx.cDbqkText = item.text;
                    this.bqJbxx.cDbqk = item.keyId;
                    this.showDBQK = false
                }).catch(() => {
                    // on cancel
                    this.showDBQK = false
                });
            }else{
                this.bqJbxx.cDbqkText = item.text;
                this.bqJbxx.cDbqk = item.keyId;
                this.showDBQK = false
            }
            window.sessionStorage.setItem("dbqk",item.keyId)
        },
        //选择案号年份
        onConfirmAhNf(item) {
            console.log('--onConfirmAhNf 000',item);
            this.bqJbxx.cAhNf = item.text;
            this.showAhNf = false
        },
        /**
         * 案由确认事件
         * @param {String} ayId 案由代码
         * @param {String} ayName 案由名称
         * */
        onConfirmAy(ayId, ayName) {
            // 案由名称
            this.bqJbxx.cAy = ayName;
            // 案由显示名称
            this.bqJbxx.cAyName = ayName;
            // 案由名称
            this.bqJbxx.cAycode = ayId;
            // 隐藏案由弹层
            this.showAyPopup = false;
        },
        /**
         * 案由行为确认事件
         * @param {Array<String>} checkedList 勾选列表
         * */
        onConfirmAyXw(checkedList) {
            let _cAy = [], _cAyCode = [];
            checkedList.length && checkedList.forEach(item => {
                _cAyCode.push(item.id);
                _cAy.push(item.name);
            })
            // 案由行政行为
            this.bqJbxx.cAyxzxw = _cAyCode.join(',');
            // 行政行为名称
            this.bqJbxx.cAyxzxwName = _cAy.join(';');
            // 行政案由名称
            this.bqJbxx.cXzaymc = this.bqJbxx.cAyxzxwName;
            // 隐藏案由弹层
            this.showAyXwPopup = false;
        },
        /**
         * 重置案由数值
         * @returns {void}
         * */
        resetAyValue() {
            // 案由重置
            this.bqJbxx.cAy = '';
            // 案由代码值
            this.bqJbxx.cAycode = '';
            // 案由名称为空
            this.bqJbxx.cAyName = '';
            // 案由行政行为
            this.bqJbxx.cAyxzxw = '';
            // 案由行政行为名称
            this.bqJbxx.cAyxzxwName = '';
            // 行政案由名称
            this.bqJbxx.cXzaymc = '';
        },

        /**
         * 案件类型确认事件
         * @params {Object} item 案件类型信息项
         * @returns {void}
         * */
        onConfirmAJLX(item) {
            this.showAJLX = false;
            // 如果选择的是同一个，则退出
            if (item.keyId == this.bqJbxx.nAjlx) {
                return;
            }
            this.bqJbxx.nAjlx = item.keyId;
            this.bqJbxx.nAjlxText = item.text;
            // 重置案由value
            this.resetAyValue();
        },
        //无需担保原因
        onConfirmWXDB(item){
            this.bqJbxx.nWdbyy = item.keyId;
            this.bqJbxx.nWdbyyText = item.text;
            this.showWXDB = false
        },
        //保存修改的内容
        modifyBasic(){
            const validated = this.validateFormData();
            validated.then(() => {
                // 如果案号是下拉选择的，则从数组里取中文名；是手填时，拼接案号名称
                if (this.bqJbxx.cBqlb === '2' &&　this.ahList.length) {
                    const index = this.ahList.findIndex(item => item.cAh === this.bqJbxx.cBqah);
                    this.bqJbxx.cAhdm = this.ahList[index].cAhdm;
                } else {
                    this.bqJbxx.cBqah = `（${this.bqJbxx.cAhNf}）${this.bqJbxx.cAhFydz}${this.bqJbxx.cAhAjlxdz}${this.bqJbxx.cAhAjxh}号`;
                }
                console.log('_____cBqlb：', this.bqJbxx.cBqlb);
                console.log('_____案号：', this.bqJbxx.cBqah);
                this.saveInfo();
            });
        },
        // 把原来的保存接口调用提出来一个方法，里面代码没改
        saveInfo() {
            this.$axios.put('ssbq/api/bqsq', this.bqJbxx).then(res => {
                if (res.code === 200) {
                    this.$notify({
                        type: 'success',
                        message: '保存成功'
                    });
                    history.go(-1);
                } else {
                    this.$notify(res.message);
                }
            });
        }
    },
    computed: {
        RMB: function () {
            let num = Number(this.bqJbxx.nSqbqje) === Number(this.bqJbxx.nSqbqje) ? Number(this.bqJbxx.nSqbqje) : 0
            if (num < 1000) {
                num = 30
            } else if (num < 100000) {
                num = 30 + (num - 1000) * 0.01
            } else {
                num = 1020 + (num - 100000) * 0.005
            }
            return num > 5000 ? 5000.00 : num.toFixed(2)
        },
        // 选择案由的label
        ayLabel() {
            let {cAhNf, nAjlx} = this.bqJbxx;
            var key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
            const label = {
                label1: Number(nAjlx) === 6 ? '案由(主体类型)' : '案由',
                label2: '行政案由'
            };
            if (key === 2020) {
                label.label2 = '案由(行为种类)';
            }
            return label;
        }
    },
}
